export default __webpack_public_path__ + "70f6ec1fc404b225541490b50c009b77.png";